import { createSelector } from "reselect";

const selectUser = (state) => state.user;

export const selectAuthenticationData = createSelector(
  [selectUser],
  (user) => user.authenticationData
);

export const selectIsLoading = createSelector(
  [selectUser],
  (user) => user.loading
);

export const selectVerifiedStatus = createSelector(
  [selectUser],
  (user) => user.isVerified
);

export const selectErrorMessage = createSelector(
  [selectUser],
  (user) => user.error
);
export const selectMfaStatus = createSelector(
  [selectUser],
  (user) => user.mfaStatus
);

export const selectQrCodeData = createSelector(
  [selectUser],
  (user) => user.qrCodeData
);

export const selectQrCodeLoading = createSelector(
  [selectUser],
  (user) => user.qrCodeLoading
);

export const selectUserLoading = createSelector(
  [selectUser],
  (user) => user.userLoader
);

export const selectUserName = createSelector(
  [selectUser],
  (user) => user.userName
);

export const selectUserEmail = createSelector(
  [selectUser],
  (user) => user.userEmail
);

export const selectUserPermission = createSelector(
  [selectUser],
  (user) => user.userPermission
);

export const selectCorpDetails = createSelector(
  [selectUser],
  (user) => user.corpDetails
);
